function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7717 2.59197C21.63 2.5111 21.4549 2.50794 21.3103 2.5839L16.2626 5.23955V2.24549C16.2611 1.00591 15.2186 0.00140343 13.9321 0H2.33051C1.044 0.00140343 0.00145657 1.00591 0 2.24549V14.0023C0.00145657 15.2419 1.044 16.2464 2.33051 16.2478H13.9321C15.2186 16.2464 16.2611 15.2419 16.2626 14.0023V10.9478L21.3105 13.6035C21.4549 13.6795 21.6302 13.6765 21.7717 13.5956C21.9133 13.5145 22 13.3677 22 13.2093V2.97809C22 2.8195 21.9132 2.67284 21.7717 2.59197ZM15.33 14.0025C15.3293 14.7463 14.7037 15.3489 13.9317 15.3498H2.33051C1.55853 15.3489 0.933114 14.7463 0.932203 14.0025V2.24549C0.933114 1.50185 1.55853 0.899075 2.33051 0.898198H13.9321C14.7039 0.899075 15.3295 1.50185 15.3304 2.24549L15.33 14.0025ZM21.0678 12.4525L16.2626 9.92456V6.26283L21.0678 3.73507V12.4525Z",
  fill: "white"
});

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.815d691e.svg";
export { ForwardRef as ReactComponent };